import codes from "@irati/deals/errorCodes/PerksSettings"

export default function perksSettingsErrorHandler(code: string) {
  switch (code) {
    case codes.SettingsAlreadyExistForTenant:
      return "errors.PBDEASettingAlreadyExistForTenant"
    default:
      return ""
  }
}
